
import dayjs from 'dayjs'

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import TabMenu from '~/components/Common/UI/TabMenu'
import Calendar from '~/components/EventNews/CalendarMonth'
import ScheduleMemo from '~/components/EventNews/ScheduleMemo'
import DailySchedule from '~/components/EventNews/DailySchedule'

import schedule from '~/api/mock/event/month' // local test
import api from '~/api/' // server

export default {
    name: 'EventNewsMonth',

    components: { Calendar, TabMenu, ScheduleMemo, DailySchedule },

    data() {
        return {
            tabData: [
                { title: '연간', route: './Year', on: false },
                { title: '월간', route: './Month', on: true },
                { title: '주간', route: './Week', on: false },
                { title: '전체보기', route: './All', on: false },
            ],

            newsTypes: [
                { text: '전체보기', value: 'MENU_EVENT_ALL' },
                { text: '주요 경제 지표', value: 'MENU_EVENT_MAJOR_ECONOMY' },
                {
                    text: '기업/산업 이슈',
                    value: 'MENU_EVENT_ENTERPRISE_ISSUE',
                },
                {
                    text: '기업 실적 발표',
                    value: 'MENU_EVENT_ENTERPRISE_ANNOUNCE',
                },
                { text: '청약/상장/폐지 등', value: 'MENU_EVENT_STOCK_ISSUE' },
                { text: '휴장일 및 기타', value: 'MENU_EVENT_CLOSED_ETC' },
            ],

            curDate: dayjs(),
            schedule: null,
            scheduleItems: [],
            newsType: '',
            itemId: '',
        }
    },

    computed: {
        ...mapState('main', ['cal_detail']),
    },

    created() {
        this.init()

        const eventDate = this.cal_detail.eventDate
        if (eventDate) {
            const ed = dayjs(eventDate)

            this.curDate = ed
            this.getScheduleWithParams(eventDate)
            return
        }

        this.getSchedule()
    },

    methods: {
        // 초기화
        init() {
            this.newsType = this.newsTypes[0].value
        },

        async getSchedule() {
            this.schedule = null

            // this.newsType
            console.log('this.newsType', this.newsType)

            const params = {
                menuType: this.newsType,
                date: this.curDate.format('YYYYMM'),
                condition: '',
            }
            console.log(params)
            this.schedule = (await api.getMonthSchedule(params)).data
            this.scheduleItems = this.schedule.items
            console.log('this.scheduleItems', this.schedule)

        },

        // 메인페이지 증시캘린더를 통해 오는 경우 params 변경
        async getScheduleWithParams(eventDate) {
            this.schedule = null

            // this.newsType
            console.log('this.newsType', this.newsType)

            const params = {
                menuType: this.newsType,
                date: eventDate.slice(0, 6),
                condition: '',
            }
            this.schedule = (await api.getMonthSchedule(params)).data
            this.scheduleItems = this.schedule.items
        },

        onChangeSelect() {
            this.getSchedule()
        },

        onClickPrev() {
            this.curDate = this.curDate.subtract(1, 'month')
            console.log('this.curDate', this.curDate)
            this.getSchedule()
        },
        onClickNext() {
            this.curDate = this.curDate.add(1, 'month')
            console.log('this.curDate', this.curDate)
            this.getSchedule()
        },

        onClickFilter(idx) {
            this.newsType = this.newsTypes[idx].value
            this.getSchedule()
        },
        getItemId(id) {
            this.itemId = id
        },
    },
}
